export default "__VITE_ASSET__BopyZK5s__"